module.exports = __webpack_public_path__ + "static/img/message.1fbaa155.svg";